import {  Tabs, Badge } from 'antd'
import React, { useState } from 'react'
import Main from '../../cpn/Main';
import InvoiceListAdd from './InvoiceListAdd';
import { PlusOutlined, ClockCircleOutlined, ScheduleOutlined, AuditOutlined, FileDoneOutlined, FileSearchOutlined } from '@ant-design/icons';
import InvoiceListPendding from './InvoiceListPendding';
import InvoiceListSubmitted from './InvoiceListSubmitted';
import InvoiceListNeedRead from './InvoiceListNeedRead';
import InvoiceListNeedApprove from './InvoiceListNeedApprove';
import InvoiceListApproved from './InvoiceListApproved';
import InvoiceListAll from './InvoiceListAll';
function InvoiceList(props) {
    const yh_qx = props.yh_qx || '';
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-ld_invoice_active_key') || '1');

    return (
        <Main 
            selectedKeys={['/InvoiceList']}
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            yh_qx={props.yh_qx}
        >                            
           <Tabs
                activeKey={activeKey} 
                onChange={(key) => {    
                    setActiveKey(key)
                    localStorage.setItem('jtg-ld_invoice_active_key', key)
                }}
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <InvoiceListAdd qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} yh_qx={yh_qx}/>,
                        icon: <PlusOutlined />, 
                    },
                    {
                        key: '1',
                        label: '我未提交的',
                        children: <InvoiceListPendding 
                                        invoiceList={props.invoiceList} 
                                        invoiceRejectedNum={props.invoiceRejectedNum} 
                                        invoiceNeedApproveNum={props.invoiceNeedApproveNum} 
                                        invoiceNeedReadNum={props.invoiceNeedReadNum} 
                                        invoiceSpList={props.invoiceSpList}
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name} 
                                        yh_id={props.yh_id} 
                                        yh_name={props.yh_name} 
                                        yh_qx={yh_qx}
                                    />,
                        icon: <ClockCircleOutlined />, 
                    },
                    {
                        key: '2',
                        label: <span>我已提交的<Badge count={Number(props.invoiceRejectedNum) + Number(props.invoiceEndNeedReadNum)}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <InvoiceListSubmitted 
                                        invoiceList={props.invoiceList} 
                                        invoiceRejectedNum={props.invoiceRejectedNum} 
                                        invoiceNeedApproveNum={props.invoiceNeedApproveNum} 
                                        invoiceNeedReadNum={props.invoiceNeedReadNum} 
                                        invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
                                        invoiceSpList={props.invoiceSpList}
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name} 
                                        yh_id={props.yh_id} yh_name={props.yh_name} 
                                        yh_qx={yh_qx}
                                    />,
                        icon: <ScheduleOutlined />, 
                    },
                    {
                        key: '3',
                        label: <span>需要我审批的<Badge count={props.invoiceNeedApproveNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <InvoiceListNeedApprove 
                                    invoiceRejectedNum={props.invoiceRejectedNum} 
                                    invoiceNeedApproveNum={props.invoiceNeedApproveNum} 
                                    invoiceNeedReadNum={props.invoiceNeedReadNum} 
                                    invoiceSpList={props.invoiceSpList}
                                    qy_id={props.qy_id} 
                                    qy_name={props.qy_name} 
                                    yh_id={props.yh_id} 
                                    yh_name={props.yh_name} 
                                    yh_qx={yh_qx}
                                />,
                        icon: <AuditOutlined />, 
                    },
                    {
                        key: '4',
                        label: <span>我已审批的<Badge count={props.invoiceRejectedNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <InvoiceListApproved 
                                        invoiceRejectedNum={props.invoiceRejectedNum} 
                                        invoiceNeedApproveNum={props.invoiceNeedApproveNum} 
                                        invoiceNeedReadNum={props.invoiceNeedReadNum} 
                                        invoiceSpList={props.invoiceSpList}
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name} 
                                        yh_id={props.yh_id} 
                                        yh_name={props.yh_name} 
                                        yh_qx={yh_qx}
                                />,
                        icon: <FileDoneOutlined />, 
                    },
                    {
                        key: '5',
                        label: <span>抄送给我的<Badge count={props.invoiceNeedReadNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <InvoiceListNeedRead 
                                        invoiceRejectedNum={props.invoiceRejectedNum} 
                                        invoiceNeedApproveNum={props.invoiceNeedApproveNum} 
                                        invoiceNeedReadNum={props.invoiceNeedReadNum} 
                                        invoiceSpList={props.invoiceSpList}
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name} 
                                        yh_id={props.yh_id} 
                                        yh_name={props.yh_name} 
                                        yh_qx={yh_qx}
                                    />,
                        icon: <FileDoneOutlined />, 
                    },
                    ...(yh_qx.includes('管理') ? [{
                        key: '6',
                        label: '全部单据',
                        children: <InvoiceListAll qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} list={props.invoiceList} yh_qx={yh_qx}/>,
                        icon: <FileSearchOutlined />,
                    }] : []),
                ]} 
            />
        </Main>
    )
}
export default InvoiceList